import { Box, Typography } from "@mui/material";

export const FieldWrapper = ({ label, applyMaxWidth = false, children }: { label: string; applyMaxWidth?: boolean; children: JSX.Element }) => (
  <Box display="flex" flexDirection="column" gap={1} minWidth={250} maxWidth={applyMaxWidth ? 500 : undefined}>
    <Typography variant="subtitle2">
      {label}
    </Typography>
    {children}
  </Box>
);
